import { Directive, inject, OnInit, signal } from '@angular/core';
import { FiDialogsService } from '../../fi-dialogs';
import { FiDialogCloseReason } from '../../fi-dialogs/fi-dialogs-close-reason';
import { FiDialogsContentBase } from '../../fi-dialogs/fi-dialogs-content-base';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';

export interface INewWidgetDialogResult<TResult> {
    openTypeSelectStep?: boolean;
    widget?: TResult;
}

@Directive()
export abstract class NewWidgetDialogBaseDirective<TReportType, TResult>
    extends FiDialogsContentBase<TReportType, INewWidgetDialogResult<TResult>>
    implements OnInit
{
    protected readonly fiDialogsService = inject(FiDialogsService);
    protected currentReportWidgetType: TReportType = this.data;
    protected reportWidget: TResult = null;
    protected loading = signal(false);

    protected abstract createCurrentReportWidget(): void;
    protected abstract getCanCloseWithoutConfirmation(): boolean;

    ngOnInit(): void {
        this.createCurrentReportWidget();
    }

    protected isReportWidgetTypeSet(): boolean {
        return !isNullOrUndefined(this.reportWidget);
    }

    protected backButtonClick(): void {
        // this.getNoButtonClickPromise().then((result) => {
        //     if (result.canClose) {
                this.dialogRef.close({
                    reason: FiDialogCloseReason.YesButton,
                    value: {openTypeSelectStep: true}
                });
        //     }
        // });
    }

    protected closeDialog(): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.NoButton,
        });
    }

    protected saveWidget(widget: TResult): void {
        this.dialogRef.close({
            reason: FiDialogCloseReason.YesButton,
            value: {widget},
        });
    }

    public getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(this.getCanCloseWithoutConfirmation());
    }
}
